import { defineStore } from 'pinia';
import api from '../axios';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || '',
  }),
  actions: {
    async login(credentials) {
      const response = await api.post('/login', credentials);
      this.token = response.data.token;
      localStorage.setItem('token', this.token);
      await this.fetchUser();
    },
    async fetchUser() {
      const response = await api.get('/user', {
        headers: { Authorization: `Bearer ${this.token}` },
      });
      this.user = response.data;
    },
    logout() {
      this.user = null;
      this.token = '';
      localStorage.removeItem('token');
    },
  },
});
